// extracted by mini-css-extract-plugin
export var navbarContainer = "NavBar-module--navbarContainer--dbeMF";
export var logo = "NavBar-module--logo--E9FrA";
export var links = "NavBar-module--links--iIPYf";
export var navbarItem = "NavBar-module--navbarItem--hzGus";
export var navbarItemActive = "NavBar-module--navbarItemActive--89PvE NavBar-module--navbarItem--hzGus";
export var icons = "NavBar-module--icons--6t6tk";
export var burgerIcon = "NavBar-module--burgerIcon--rR5d3";
export var burgerMenu = "NavBar-module--burgerMenu--GRu58";
export var open = "NavBar-module--open--GSnfK";